import { Input } from '@components/atoms/Input';
import { FlexWrapper } from '@components/layouts/flex-wrapper';
import { PhoneNumberInput } from '@components/phone-number-input';
import Oferta from '@assets/img/oferta.pdf';

import {
  Button,
  ChangePage,
  CheckerImg,
  CheckerTitle,
  EyeButton,
  EyeImg,
  Form,
  FormGroup,
  HaveProfile,
  InputError,
  InputLabels,
  InputLongError,
  PasswordChecker
} from '@modules/new-auth/routes/login/login.style';
import { hoc } from '@utils/hoc';
import { usePhoneFormProp } from './phone-form.prop';

import InfoImg from '@assets/img/info.svg';
import CloseEyeImage from '@assets/img/close-eye.svg';
import OpenEyeImage from '@assets/img/open-eye.svg';
import NotMatch from '@assets/img/not-match.svg';
import Empty from '@assets/img/empty.svg';
import Success from '@assets/img/checksuccess.svg';

import {
  InfoImage,
  InfoText,
  RegExInfoText,
  RegisterBottom
} from './phone-form.style';
import { RegisterWithGoogle } from '../RegisterWithGoogle';
import { ConfirmCode } from './confirm-code';
import {
  invalid,
  PASSWORD_LONG_ERROR_MIN_LENGTH
} from '@modules/new-auth/constants';
import { PasswordRequirementsChecker } from '@modules/new-auth/components/PasswordRequirementsChecker';

export const PhoneForm = hoc(
  usePhoneFormProp,
  ({
    hasChecker,
    formik,
    inputType,
    checkInputType,
    handleChangeNewPasswordType,
    handleChangeCheckInputType,
    handleBlurUserName,
    handleChangeUserName,
    handleBlurPhoneNumber,
    handleChangePhoneNumber,
    handleBlurPassword,
    handleChangePassword,
    handleFocusPassword,
    handleBlurPasswordCheck,
    handleChangePasswordCheck,
    confirmModal,
    supportLink,
    handleRecaptchaChange,
    isCaptchaError
  }) => {
    return (
      <>
        <Form onSubmit={formik.handleSubmit}>
          <FormGroup mb>
            <InputLabels htmlFor='firstName'>Ismingiz</InputLabels>

            <Input
              onBlur={handleBlurUserName}
              placeholder='Ismingizni kiriting'
              name='firstName'
              id='firstName'
              value={formik.values.firstName}
              onChange={handleChangeUserName}
              className={
                formik.errors?.firstName && formik.errors?.firstName !== invalid
                  ? 'input-error'
                  : formik.errors?.firstName === invalid
                  ? 'input-info'
                  : ''
              }
            />

            {formik.errors?.firstName !== invalid && (
              <InputError>{formik.errors?.firstName}</InputError>
            )}
            {formik.errors?.firstName === invalid && (
              <RegExInfoText phone>
                Siz faqat ushbu harf va belgilardan foydalana olasiz: A-Z a-z
                0-9 '
              </RegExInfoText>
            )}
          </FormGroup>

          <FormGroup mb>
            <InputLabels htmlFor='phone'>Telefon raqam</InputLabels>

            <PhoneNumberInput
              format='## ### ## ##'
              prefix='+998'
              placeholder='00 000 00 00'
              id='phone'
              name='phone'
              onBlur={handleBlurPhoneNumber}
              onChange={handleChangePhoneNumber}
              values={formik.values.phone}
              className={formik.errors?.phone ? 'input-error' : ''}
            />
            {formik.errors?.phone && (
              <InputError>{formik.errors?.phone}</InputError>
            )}
          </FormGroup>

          <FormGroup
            isError={
              formik.errors?.password?.length > PASSWORD_LONG_ERROR_MIN_LENGTH
            }
            mb
          >
            <InputLabels isError={true} htmlFor='password'>
              Parol
            </InputLabels>

            <FlexWrapper
              className={`wrapper ${
                formik.errors.password ? 'input-error' : ''
              }`}
              align='center'
              justify='space-between'
            >
              <Input
                name='password'
                type={inputType}
                id='password'
                className='password-input'
                onFocus={handleFocusPassword}
                onBlur={handleBlurPassword}
                value={formik.values.new_password}
                onChange={handleChangePassword}
                placeholder='Parolingizni kiriting'
              />
              <EyeButton type='button'>
                <EyeImg
                  src={inputType === 'password' ? CloseEyeImage : OpenEyeImage}
                  alt='eye'
                  onClick={handleChangeNewPasswordType}
                />
              </EyeButton>
            </FlexWrapper>
            {hasChecker && (
              <PasswordRequirementsChecker
                password={formik.values.password}
              ></PasswordRequirementsChecker>
            )}
            {formik.errors?.password && (
              <InputLongError>{formik.errors?.password}</InputLongError>
            )}
          </FormGroup>

          <FormGroup formAd>
            <InputLabels
              className={
                formik.errors.new_password_check &&
                formik.touched.new_password_check &&
                'error'
              }
              isError={true}
              htmlFor='new_password_check'
            >
              Parolni tasdiqlash
            </InputLabels>

            <FlexWrapper
              className={`wrapper ${
                formik.errors.password_check ? 'input-error' : ''
              }`}
              align='center'
              justify='space-between'
            >
              <Input
                name='password_check'
                type={checkInputType}
                id='password_check'
                className='password-input'
                onBlur={handleBlurPasswordCheck}
                value={formik.values.new_password_check}
                onChange={handleChangePasswordCheck}
                placeholder='Parolingizni kiriting'
              />
              <EyeButton type='button'>
                <EyeImg
                  src={
                    checkInputType === 'password' ? CloseEyeImage : OpenEyeImage
                  }
                  alt='eye'
                  onClick={handleChangeCheckInputType}
                />
              </EyeButton>
            </FlexWrapper>
            {formik.errors?.password_check && (
              <InputError>{formik.errors?.password_check}</InputError>
            )}
          </FormGroup>

          <FlexWrapper mb='28px' gap='9px'>
            <InfoImage src={InfoImg} alt='info img' />

            <InfoText>
              Agarda siz O’zbekistondan tashqarida istiqomat qilib telefon raqam
              orqali ro’yxatdan o’tmoqchi bo’lsangiz,
              <span>
                <a
                  href={supportLink ? supportLink : '/'}
                  target='_blank'
                  rel='noreferrer'
                >
                  qo’llab-quvvatlash xizmati
                </a>
              </span>
              orqali murojaat qilib telefon raqamni ro’yxatdan o’tkazishingiz
              mumkin.
            </InfoText>
          </FlexWrapper>
          <FlexWrapper mb='16px' gap='12px'>
            <RegisterWithGoogle />
            <Button type='submit' min>
              Ro‘yxatdan o‘tish
            </Button>
          </FlexWrapper>
        </Form>

        <InfoText oferta>
          Ro‘yxatdan o‘tish tugamasini bosish orqali siz
          <a target='_blank' href={Oferta} rel='noreferrer'>
            Shaxsiy ma’lumotlarni
          </a>
          qayta ishlash va
          <a href={Oferta} target='_blank' rel='noreferrer'>
            Foydalanish qoidalariga
          </a>
          rozilik bildirasiz
        </InfoText>

        <RegisterBottom>
          <HaveProfile>Ro‘yxatdan o‘tganmisiz?</HaveProfile>

          <ChangePage to='/auth/login'>Profilga kirish</ChangePage>
        </RegisterBottom>

        {confirmModal && <ConfirmCode />}
      </>
    );
  }
);
